
import { CORE_AXIOS, type Http } from "@/core"
import { container } from "tsyringe"


// 发布评价
export const createComment = async (data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.post(`/v1/api/comment`, data)
}

export const createReply = async (id: any, data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.post(`/v1/api/comment/${id}/reply`, data)
}


export const deleteComment = async (id: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.delete(`/v1/api/comment/${id}`)
}

export const updateComment = async (id: number, data: any): Promise<void> => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return await axios.put(`/v1/api/comment/${id}`, data)
}
